export const useSetLocale = () => {
  const locale = localStorage.getItem('locale')

  if (locale && locale === 'ru-ru') {
    localStorage.setItem('locale', 'ru')
  }
}
